var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import ClearIcon from '@mui/icons-material/HighlightOff';
import { IconButtonWithTooltip } from '../../button';
export var ClearArrayButton = function (props) { return (React.createElement(IconButtonWithTooltip, __assign({ label: "ra.action.clear_array_input", size: "small", color: "warning" }, props),
    React.createElement(ClearIcon, { fontSize: "small" }))); };
export default null;
//# sourceMappingURL=ClearArrayButton.js.map